(function() {
  'use strict';
  
  // Mobile Nav Accordion
  
  // Mobile Navigation Accordion Functionality
  const MobileNavAccordion = {
    init: function() {
      // Only initialize on mobile and if accordion mode is active
      if (window.innerWidth > 767 || !$('#page-menu').hasClass('nav-uses-accordion')) {
        
        return;
      }
      
      if (!$('#page-menu').length) {
        // Page menu element not found
        return;
      }
      
      
      
      // Remove ALL existing navigation click handlers to start clean
      this.cleanupAllHandlers();
      
      // Initialize accordion behavior
      this.setupAccordion();
      this.openDefaultSections();
      
      
    },
    
    cleanupAllHandlers: function() {
      
      
      // Remove any delegated handlers bound on document
      $(document).off('click', '#page-menu .main-nav li.has-children > a');
      $(document).off('click', '#page-menu .main-nav li > a');
      $(document).off('click', '.main-nav li.has-children > a');
      $(document).off('click', '.main-nav li > a');
      $(document).off('click', '#page-menu.nav-uses-modal .main-nav li.has-children > a');
      $(document).off('click', '#page-menu.nav-uses-modal a[data-revert-back]');
      $(document).off('click.accordion', '#page-menu.nav-uses-accordion .main-nav li.has-children > a[data-accordion-toggle]');
      
      // Remove any directly bound click handlers on anchors inside the menu
      $('#page-menu .main-nav li.has-children > a').off('click');
      $('#page-menu .main-nav li > a').off('click');
      $('#page-menu.nav-uses-modal a[data-revert-back]').off('click');
    },
    
    setupAccordion: function() {
      const self = this;
      
      
      
      // Ensure any previous accordion handlers are removed before rebinding
      $(document).off('click.accordion', '#page-menu.nav-uses-accordion .main-nav li.has-children > a[data-accordion-toggle]');

      // Handle accordion toggle clicks - only for accordion mode (namespaced)
      $(document).on('click.accordion', '#page-menu.nav-uses-accordion .main-nav li.has-children > a[data-accordion-toggle]', function(e) {
        
        
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation(); // Stop other handlers on same element
        
        const $link = $(this);
        const $parent = $link.parent('li');
        const $submenu = $parent.find('> ul');
        
        // Check if animation is already running
        if ($submenu.is(':animated')) {
          return false;
        }
        
        const isExpanded = $parent.hasClass('expanded');
        
        
        
        if (isExpanded) {
          self.collapseSection($parent, $submenu);
        } else {
          self.expandSection($parent, $submenu);
        }
        
        return false;
      });

      // Ensure arrow icon exists on toggles
      $('#page-menu.nav-uses-accordion .main-nav li.has-children > a[data-accordion-toggle]').each(function() {
        var $a = $(this);
        if ($a.find('> .arr').length === 0 && typeof theme !== 'undefined' && theme.icons && theme.icons.chevronRight) {
          $a.append('<span class="arr">' + theme.icons.chevronRight + '</span>');
        }
      });
    },
    
    expandSection: function($parent, $submenu) {
      
      
      $parent.addClass('expanded');
      $submenu.stop(true, true).slideDown(250, function() {
        // Ensure visibility after animation
        $(this).css('display', 'block');
        
      });
      
      // Rotate arrow icon if present
      $parent.find('> a .arr').addClass('rotated');
    },
    
    collapseSection: function($parent, $submenu) {
      
      
      $parent.removeClass('expanded');
      $submenu.stop(true, true).slideUp(250, function() {
        
      });
      
      // Reset arrow icon rotation
      $parent.find('> a .arr').removeClass('rotated');
    },
    
    openDefaultSections: function() {
      const self = this;
      
      // Find sections marked to be expanded by default
      $('#page-menu.nav-uses-accordion .main-nav li[data-default-expanded="true"]').each(function() {
        const $parent = $(this);
        const $submenu = $parent.find('> ul');
        
        if ($submenu.length) {
          // Expand without animation on initial load
          $parent.addClass('expanded');
          $submenu.css('display', 'block');
          $parent.find('> a .arr').addClass('rotated');
        }
      });
    },
    
    reset: function() {
      // Reset accordion state when modal closes
      $('#page-menu.nav-uses-accordion .main-nav li.expanded').each(function() {
        const $parent = $(this);
        const $submenu = $parent.find('> ul');
        
        // Keep default-expanded sections open
        if (!$parent.attr('data-default-expanded')) {
          $parent.removeClass('expanded');
          $submenu.css('display', 'none');
          $parent.find('> a .arr').removeClass('rotated');
        }
      });
    }
  };
  
  // Initialize on DOM ready with multiple fallbacks
  function tryInit() {
    
    
    if (typeof $ !== 'undefined' && $('#page-menu').length) {
      MobileNavAccordion.init();
    } else {
      setTimeout(tryInit, 100);
    }
  }
  
  // Try immediate initialization (in case document is already ready)
  if (document.readyState === 'loading') {
    $(document).ready(function() {
      // Initial setup
      tryInit();
      setupEventHandlers();
      fixInitialLogoState();
    });
  } else {
    // DOM is already ready
    tryInit();
    setupEventHandlers();
    fixInitialLogoState();
  }
  
  function fixInitialLogoState() {
    try {
      // Fix initial logo state and scroll handler on page load
      const $body = $('body');
      const $siteControl = $('.site-control');
      
      
      
      // Apply initial scroll state on page load
      if ($body.hasClass('nav-transparent') && 
          $body.hasClass('header-section-overlap') &&
          typeof theme !== 'undefined' && theme.Nav && typeof handleScroll === 'function') {
        const nav = theme.Nav();
        const positioning = nav.bar.getPositionSetting ? nav.bar.getPositionSetting() : 'sticky';
        const opacity = nav.bar.getOpacitySetting ? nav.bar.getOpacitySetting() : 'opaque';
        handleScroll(nav, positioning, opacity);
        
      }
      
      // Let theme.assessAltLogo + CSS handle logo color/alt state
    } catch (err) {}
  }
  
  function setupEventHandlers() {
    // Re-initialize when page menu is opened
    $(document).on('click', '.menu', function() {
      setTimeout(function() {
        MobileNavAccordion.init();
      }, 100);
    });
    
    // Header reassessment helper (no rebinding of scroll handlers)
    function reassessHeaderOnce() {
      try {
        if (typeof theme !== 'undefined' && typeof theme.assessAltLogo === 'function') {
          theme.assessAltLogo();
        }
        if (typeof theme !== 'undefined' && theme.Nav && typeof handleScroll === 'function') {
          const nav = theme.Nav();
          const positioning = nav.bar.getPositionSetting ? nav.bar.getPositionSetting() : 'sticky';
          const opacity = nav.bar.getOpacitySetting ? nav.bar.getOpacitySetting() : 'opaque';
          handleScroll(nav, positioning, opacity);
        }
      } catch (err) {}
    }

    // After modal fully closes, restore header visuals (avoid double-trigger during transition)
    $(window).on('ccModalClosed', function() {
      reassessHeaderOnce();
    });

    // After opening the nav modal, re-assess once it has revealed
    $(document).on('click', '.site-control a[data-modal-nav-toggle]', function() {
      setTimeout(function() {
        reassessHeaderOnce();
      }, 400);
    });

    // Re-initialize on window resize (in case of orientation change)
    let resizeTimer;
    $(window).on('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        MobileNavAccordion.init();
        reassessHeaderOnce();
      }, 250);
    });
    
    // Reset accordion when modal closes
    $(document).on('reset-modal', '#page-menu.nav-uses-accordion', function() {
      MobileNavAccordion.reset();
      reassessHeaderOnce();
    });
  }
  
  /**
   * Fix pre-existing modal issues (scroll blocking + logo state persistence)
   */
  // Removed modal fix overrides; legacy drilldown is now disabled in accordion mode
  
  // Initialize after Shopify theme sections load
  $(document).on('shopify:section:load', function() {
    setTimeout(function() {
      MobileNavAccordion.init();
    }, 100);
  });
  
  // Expose to global scope for debugging
  window.MobileNavAccordion = MobileNavAccordion;
})();